var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgArchive = function SvgArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6629_15642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.75 2H2.74998C2.38179 2 2.08331 2.29848 2.08331 2.66667V4.66667C2.08331 5.03486 2.38179 5.33333 2.74998 5.33333H14.75C15.1182 5.33333 15.4166 5.03486 15.4166 4.66667V2.66667C15.4166 2.29848 15.1182 2 14.75 2Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.41669 5.33325V12.6666C3.41669 13.0202 3.55716 13.3593 3.80721 13.6094C4.05726 13.8594 4.3964 13.9999 4.75002 13.9999H12.75C13.1036 13.9999 13.4428 13.8594 13.6928 13.6094C13.9429 13.3593 14.0834 13.0202 14.0834 12.6666V5.33325",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41669 8H10.0834",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6629_15642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.75)"
  })))));
};
export default __webpack_public_path__ + "assets/01f39989b12536be30cce31ac2f458db.svg";
export { SvgArchive as ReactComponent };


// WEBPACK FOOTER //
// ./assets/icons/archive.svg